import { render, staticRenderFns } from "./ConfCuenta.vue?vue&type=template&id=190c3a6e"
import script from "./ConfCuenta.vue?vue&type=script&lang=js"
export * from "./ConfCuenta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports